<template>
   
<div id="Vue"  > 
  <div class="container">
 
 
  <div class='has-info'  >
  <div   style="align-items:center;text-align:center;float:center;font-size:18px;margin-top:20px">
    登录您的账户
  </div>
   <el-form ref="form" :model="form"   label-width="80px" style="margin: 50px">
  <el-form-item label="手机" required>
    <el-input v-model="form.name" placeholder="手机号 "></el-input>
  </el-form-item>
  <el-form-item label="密码" required>
    <el-input v-model="form.pwd" placeholder="请输入密码 "  @keyup.enter.native="onSubmit" show-password></el-input>
  </el-form-item>
 
 	 <div   style="margin-top:10px;margin-left:10px;padding:10px;font-size:12px;color: #909399;"    >
              点击“登录”,即表示您同意遵守智造云的
	   <el-link :underline="false" href="#/terms" target="_blank" style="font-size:12px;color: #909399;">《服务条款》</el-link>
	   <el-link :underline="false" href="#/privacy" target="_blank" style="font-size:12px;color: #909399;">《隐私政策》</el-link>
     </div>
  <el-form-item style="margin-top:10px;   " >
    <el-button type="primary" :loading="is_loading" @click="onSubmit" style="width:90%" round >登录 </el-button>
  
  </el-form-item>
  	<div   class='info-item' style="margin-top:10px;margin-left:30px;padding:10px;align-items:center"  >
      <h4> 还没有账号?  <a href="#/reg">注册</a> </h4> 
	  <h4 style="margin-left:100px;float:right; ">   <a href="#/pwdChg">忘记密码</a> </h4> 
   </div>
</el-form>
 
  </div>
  
</div>
</div>
</template>
<script language="javaScript">
export default {
 
        data () {
            return {
	    	componentName: 'info',
		    userInfo: {},
			login_state : 0,
			is_loading: false, 
			form: {
			  name: '',
			  pwd: '', 
			  }
			}  
        },
        methods: {

			onSubmit() {
		 
		        let hash = {};
				hash['username'] = this.form.name;
				hash['password'] = this.form.pwd;
				if (hash.username === ''){
                   this.$message({
							message: '请填写用户名',
							type: 'warning'
							}); 
                   return
                   };
                if(hash.password === ''){
                   this.$message({
							message: '请填写密码',
							type: 'warning'
							});  
                   return
                   };
				this.is_loading = true;  
				$.post('https://www.myferp.com/admin/auth/userLogin', hash)
                 .then((response)=>{
				    this.is_loading = false;
			        if (response.errno > 0){
					   this.$message({
							message: response.errmsg,
							type: 'error'
							});
						return;
						}
				    localStorage.setItem('token',  response.data.token);
                    localStorage.setItem('userInfo',   JSON.stringify(response.data.userInfo) ); 
				    console.log('token: ' + localStorage.getItem('token')); 
				//	if (this.$route.params.requestFrom == 'customsHome'){
				//	    this.$router.replace({ name: 'customsIndex' });
				//		}
				//	else    
                        this.$router.push(
					    {path: '/customs/index'}
						); 
                 },(request)=>{
				    this.is_loading = false;
				    this.$message({
							message: '密码不匹配',
							type: 'error'
							}); 
                 })
				 
			},
			
			mounted() {
				 
				console.log('hi');
				let that = this;
				var info1 = localStorage.getItem("userInfo"); 
				var userName = '';
				var userId = 0;
				var userPhone = '';
				var userEmail = '';
				if (info1 != undefined && info1 != '' && info1 != "undefined"){
				  var info = JSON.parse(info1);
				  that.userInfo = info ;   
				  console.log(that.userInfo);
				  }else
				  {
				  console.log(info1);
				  }
			
			   } 
 

		}        

    }  ;
  
</script>

<style scoped>
  body {
    background: #eceaea;
    height: 100%;
}

.container {
    display: flex;
	flex-direction: column;
    align-items: center;
    overflow-x: hidden;
	background: #eceaea;
	padding-bottom: 60px;
}
.logo{
    display: flex;
    justify-content: flex-start;
	position: absolute;
	left: 20px;
	top: 20px;
}

.has-info {
    display: flex;
    flex-direction: column;
	margin-top:100px;
    padding: 10px;
	background: #fff;
	width: 500px;
	height: 460px;
	border-radius: 10px;
     
    margin-bottom: 10px;
    position: relative;
}

.has-info .info-item {
    padding: 30rpx 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: #fff;
   /* border-radius: 10px;
    box-shadow: 2px 2px 2px #f1f1f1; */
    margin-bottom: 20px;
    position: relative;
}

.has-info .info-item .edit-wrap{
    padding: 30rpx;
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.has-info .info-item .edit-wrap .img{
    width: 42rpx;
    height: 42rpx;
}

.has-info .info-item .selected {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30rpx 0 30rpx 30rpx;
}

.has-info .info-item .selected .img {
    width: 40rpx;
    height: 40rpx;
}

.has-info .info-item .info-wrap{
    display: flex;
    flex-direction: column;
    padding-left: 5px;
}

.has-info .info-item .info-wrap .addr {
    display: flex;
    flex-direction: column;
    margin-bottom: 10rpx;
}

.has-info .info-item .info-wrap .addr .top {
    font-size: 30rpx;
    font-weight: 500;
    margin-bottom: 5px;
}

.has-info .info-item .info-wrap .addr .text {
    font-size: 24rpx;
    color: #777;
}

.has-info .info-item .info-wrap .addr .img-wrap {
    width: 44rpx;
    height: 44rpx;
    margin-right: 10rpx;
}

.has-info .info-item .info-wrap .name {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.has-info .info-item .info-wrap .name .img-wrap {
    width: 44rpx;
    height: 44rpx;
    margin-right: 10rpx;
}

.has-info .info-item .info-wrap .name .img {
    width: 42rpx;
    height: 42rpx;
}

.has-info .info-item .info-wrap .name .default {
    font-size: 22rpx;
    color: #ff3456;
    background: #faedef;
    text-align: center;
    padding: 2rpx 10rpx;
    border-radius: 4rpx;
}

.has-info .info-item .info-wrap .name .text {
    font-size: 26rpx;
    margin-right: 10rpx;
}

.has-info .info-item .id-wrap {
    display: flex;
    flex-direction: column;
}

.has-info .info-item .id-wrap .ids {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 26rpx;
    color: #5d6777;
    margin-bottom: 8rpx;
}

.has-info .info-item .id-wrap .ids .id-name {
    margin-right: 20rpx;
}

.has-info .info-item .id-wrap .no-ids {
    font-size: 26rpx;
    color: #ffbb12;
}

.has-info .add-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    border-radius: 10rpx;
    box-shadow: 2rpx 8rpx 18rpx #f1f1f1;
    margin-bottom: 24rpx;
    padding: 30rpx 0;
}

.has-info .add-btn .icon-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40rpx;
    height: 40rpx;
    margin-right: 8rpx;
}

.has-info .add-btn .icon-wrap .img {
    width: 40rpx;
    height: 40rpx;
}

.has-info .add-btn .text {
    font-size: 28rpx;
    color: #ffc310;
}

.no-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 300rpx;
}

.no-info .img {
    width: 100rpx;
    height: 100rpx;
    margin-bottom: 30rpx;
}

.no-info .text {
    font-size: 30rpx;
    color: #999;
    text-align: center;
    margin-bottom: 30rpx;
}

.no-info .add-btn {
    color: #192841;
    /* background: #ff3456; */
    background: linear-gradient(to right, #f8dd66, #fae277);
    border-radius: 100px;
    width: 400rpx;
    height: 80rpx;
    line-height: 80rpx;
    text-align: center;
    font-size: 28rpx;
    margin: 0 auto;
}

.btn-submit { 
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.btn-submit .btn {
    width: 100%;
    background: linear-gradient(to right,  #6d97f8, #5cb3f3);
    color: #fff;
    font-size: 20px;
    text-align: center;
    height: 110rpx;
    line-height: 100rpx;
}
.btn-wrap {
    position: fixed; 
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.btn-wrap .btn {
    width: 100%;
    background: linear-gradient(to right, #6d97f8, #5cb3f3);
    color: #fff;
    font-size: 28rpx;
    text-align: center;
    height: 110rpx;
    line-height: 100rpx;
}
.error{
    color: red;
	font-size: 16px;
}
</style>

 


// WEBPACK FOOTER //
// src/components/sign_in.vue